import {
  deviceInteractionPageName,
  deviceStatusPageName,
  falseRecordingsPageName,
  iamReportWithTagInformationPageName,
  parkerExtractPageName,
  parkerPerTariffPageName,
  parkerRegistrationsPageName,
  parkerTurnoverPageName,
  reportsPageName,
  tagsPerParkerPageName,
  zoneDamagePageName,
} from '../../core/routing/page-names';
import { configurationAdministrationRoute, parkingRangerSessionsRoute, tagsAdministrationRoute, userManagementRoute } from '../../core/routing/route-names';
import { ActivatedRoute, Event, NavigationEnd, Router, RouterEvent } from '@angular/router';
import { Injectable } from '@angular/core';
import { parkerAdministrationRoute } from 'src/app/core/routing/route-names';

@Injectable({
  providedIn: 'root', // this service needs to be a singleton
})
export class WideFormatService {

  public useWideFormat = false;

  private wideFormatPages: string[] = [
    parkerAdministrationRoute.toLocaleLowerCase(),
    tagsAdministrationRoute.toLocaleLowerCase(),
    userManagementRoute.toLocaleLowerCase(),
    parkingRangerSessionsRoute.toLocaleLowerCase(),
    zoneDamagePageName.toLocaleLowerCase(),
    deviceInteractionPageName.toLocaleLowerCase(),
    reportsPageName.toLocaleLowerCase(),
    tagsPerParkerPageName.toLocaleLowerCase(),
    parkerRegistrationsPageName.toLocaleLowerCase(),
    falseRecordingsPageName.toLocaleLowerCase(),
    parkerTurnoverPageName.toLocaleLowerCase(),
    parkerExtractPageName.toLocaleLowerCase(),
    iamReportWithTagInformationPageName.toLocaleLowerCase(),
    deviceStatusPageName.toLocaleLowerCase(),
    parkerPerTariffPageName.toLocaleLowerCase(),
    configurationAdministrationRoute.toLocaleLowerCase(),
  ];

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.router.events.subscribe((event: Event|RouterEvent) => {
      if (event instanceof NavigationEnd) {
        this.useWideFormat = false;
        const navigationEnd = event as NavigationEnd;
        const url = navigationEnd.url.toLocaleLowerCase();
        this.wideFormatPages.forEach(page => {
          const index = url.indexOf(page);
          if (index !== -1 && ((url.length - index) === page.length || url[index + page.length] === '?')) {
            this.useWideFormat = true;
          }
        });
      }
    });
  }
}
